module.exports = "https://static.wmbcdn.com/uniweb/images/1d7d320b70fd881e09d631cd7f55edc2.svg";